import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function ComplaintPolicy() {
  return (
    <>
      <Header />
      <main className="main" style={{ background: 'linear-gradient(135deg, #FDFCFE 0%, #FAF8FC 50%, #F5EBFA 100%)', minHeight: '100vh' }}>
        {/* Hero Section */}
        <section style={{
          background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%), url(/assets/img/dtk4.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: '65vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            content: '',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\' fill=\'rgba(255,255,255,0.03)\'%3E%3Ccircle cx=\'25\' cy=\'25\' r=\'1\'/%3E%3Ccircle cx=\'75\' cy=\'75\' r=\'1.5\'/%3E%3C/svg%3E")',
            backgroundSize: '80px 80px',
            backgroundRepeat: 'repeat',
            animation: 'float 20s ease-in-out infinite'
          }}></div>
          <div className="container" style={{ position: 'relative', zIndex: 2 }}>
            <div className="row">
              <div className="col-lg-10 mx-auto text-center">
                <div style={{
                  backgroundColor: 'rgba(123, 63, 158, 0.15)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '24px',
                  padding: '60px 50px 40px',
                  color: 'white'
                }}>
                  <h2 style={{ fontSize: '2.5rem', fontWeight: '700', marginBottom: '10px', textShadow: '0 2px 10px rgba(123, 63, 158, 0.97)', color: '#fff' }}>
                    DTK COMPLAINTS POLICY
                  </h2>
                  <p style={{ fontSize: '1.2rem', marginBottom: 0, opacity: 0.95 }}>
                    Your Voice Matters - Fair Resolution Process
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Policy Information Table */}
        <section style={{ padding: '80px 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="shadow-lg" style={{
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  overflow: 'hidden',
                  border: '1px solid #e2e8f0'
                }}>
                  <div className="table-responsive">
                    <table className="table mb-0" style={{ fontSize: '1rem' }}>
                      <tbody>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc', width: '30%' }}>Lead Responsibility</td>
                          <td style={{ padding: '20px 30px' }}>Laurence T. Sofowora</td>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc', width: '25%' }}>Approved by</td>
                          <td style={{ padding: '20px 30px' }}>Adekunle Ayeni, Akindele Bakarey</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Version</td>
                          <td style={{ padding: '20px 30px' }}>V8 - 2026</td>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Date of Approval</td>
                          <td style={{ padding: '20px 30px' }}>19/01/2026</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Effective from</td>
                          <td style={{ padding: '20px 30px' }}>19/01/2026</td>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Next review date</td>
                          <td style={{ padding: '20px 30px' }}>January 2027</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Policy applicable to</td>
                          <td colSpan="3" style={{ padding: '20px 30px' }}>ALL EMPLOYEES and FREELANCE STAFF</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Record of Changes:</td>
                          <td colSpan="3" style={{ padding: '20px 30px' }}>Students Complaints Policy changed to Complaints Policy</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 1. Introduction */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    1. INTRODUCTION
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    DTK is a centre of learning and teaching committed to providing a high-quality educational experience. We recognise that occasionally things can go wrong. Therefore, if you have a concern/complaint the following information provides guidance on what steps can be taken and who the best person to approach would be.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    When raising concerns to DTK it is best practice to ensure that you have read the procedure carefully.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    This Procedure is the mechanism to raise concerns or complaints about the organisation's services or members. The aim is to prevent unnecessary delay, whilst ensuring a full and fair assessment of the circumstances of any individual complaint.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    The formal complaints procedure should be a last resort in the search for a solution. Prior to entering the Complaints Procedure, the individual raising the concern otherwise known as the complainant should normally have raised the issue with the person concerned.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    This procedure <strong>does not</strong> cover academic appeals for which there is a separate procedure.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 2. Operating Principles */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    2. Operating Principles
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px' }}>
                    <strong>2.1.</strong> The complaints procedure is operated under the Principles of Natural Justice.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '25px' }}>
                    <strong>2.1.1.</strong> That is the organisation acknowledges that there are two sides to every dispute. The procedure is intended to provide a non-adversarial framework where both parties are given the opportunity to provide evidence to substantiate their version of the issue/incident. Full disclosure of any allegations or evidence will be made to both parties.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '25px' }}>
                    <strong>2.1.2.</strong> Where issues cannot be resolved informally an independent Senior Manager will be appointed to consider evidence of the complaint. The manager will be from outside the area of complaint and have no previous involvement in the issue or concern.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '25px' }}>
                    <strong>2.1.3.</strong> For Higher Education Students where issues cannot be resolved through the implementation of this policy the complainant will be referred to the OIA (Office of the Independent Adjudicator) whose policy is to: "Review unresolved complaints from students against their higher education providers. If the review finds that the provider has done something wrong, we make Recommendations for them to put things right. Share learning from complaints to help improve policies and practices across the higher education sector. Work with others and contribute to the development of policy, both in the wider regulatory framework for higher education and in the Ombud sector."
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '25px' }}>
                    <strong>2.1.4.</strong> It is expected that in raising possible issues of complaint, students themselves will have observed their obligations and responsibilities as learners of the organisation, through meeting their academic commitments and a level of behaviour in accordance with the organisation's regulations or reasonable consideration for others. The organisation expects that students will not engage in frivolous or vexatious complaints.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px' }}>
                    <strong>2.2.</strong> All information supplied by the complainant will remain confidential for use within the complaints process. Only staff directly involved with the complaint resolution/investigation will be given access to the facts of the case. Complaints provide an important source of feedback on the performance of DTK's services and members. As such DTK will monitor the registration of complaints and the progress towards resolution. A report will be produced annually to monitor complaint trends and to ensure the relevant quality issues are identified and addressed. Complainant identification information will not be presented in the report. The complainant may discuss complaint issues informally with the Complaints Caseworker prior to any action being taken on the complaint.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px' }}>
                    <strong>2.3.</strong> Anonymous complaints will not be accepted.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px' }}>
                    <strong>2.4.</strong> The complainant can normally expect a written response to their complaint within 21 days of submitting a complaint form.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    <strong>2.5.</strong> Any party involved in the complaint has the right to be accompanied and represented by a person of his/her choice at every relevant stage of the procedure. The complainant may choose a representative, but they must make their own arrangements in this matter.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Complaints Process Header */}
        <section style={{ padding: '0 0 40px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="text-center">
                  <h3 style={{ color: '#7B3F9E', fontSize: '2rem', fontWeight: '700', marginBottom: '0' }}>
                    Complaints Process
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 3.1 Informal Stage I */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h4 style={{ color: '#0369a1', fontSize: '1.6rem', fontWeight: '700', marginBottom: '20px' }}>
                    3.1. Informal (Stage I)
                  </h4>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '25px' }}>
                    <strong>3.1.1.</strong> If the complaint can be resolved locally which can be obtained from DTK offices should be completed in all cases by the complainant. All complaints should normally be made within twenty-one (21) days of the alleged incident, matter, or concern. The complainant must provide evidence to support any allegations they make. Where the complainant fails to provide evidence to substantiate their allegations, DTK reserves the right not to progress the complaint to the formal stage of the procedure.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '25px' }}>
                    <strong>3.1.2.</strong> If, in the complainant's opinion, the matter is too sensitive, personal, or confidential to discuss with the tutor, the Office Manager or with the immediate manager/supervisor of the service, the issue/s can, in the first instance, be presented directly to DTK's Director of Studies.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '25px' }}>
                    <strong>3.1.3.</strong> Where appropriate a formal meeting with the Director of Studies (or their nominee) will be arranged and is intended to clarify issues surrounding the complaint. The Complainant's nominee will act as adviser. Notes of the meeting will be made, and a copy made available for the complainant.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '25px' }}>
                    <strong>3.1.4.</strong> Formal mediation may also be made available for informal resolution of complaints.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0', paddingLeft: '25px' }}>
                    <strong>3.1.5.</strong> If the matter is not resolved, normally, within twenty-one days (21) of the informal discussions the complaint may progress to the formal stage.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 3.2 Formal Stage II - General Complaints */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h4 style={{ color: '#0369a1', fontSize: '1.6rem', fontWeight: '700', marginBottom: '20px' }}>
                    3.2 Formal (Stage II): General Complaints
                  </h4>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '25px' }}>
                    <strong>3.2.1.</strong> The Complainant should write to the Director of Studies, outlining the reasons for the complaint progressing to the next stage. This should normally be done within 14 days of receipt of the response from the informal stage.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '25px' }}>
                    <strong>3.2.2.</strong> A Hearing Panel will normally be convened within twenty-eight (28) days of the request being made.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '25px' }}>
                    <strong>3.2.3.</strong> The Hearing Panel will be Chaired by a member of DTK's Directorate who will consider the case in conjunction with a staff member and nominee. The Nominee will advise the panel on matters of procedure.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '25px' }}>
                    <strong>3.2.4.</strong> The Chair will act as the final arbiter in the matter after considering the opinions of all panel members.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px', paddingLeft: '25px' }}>
                    <strong>3.2.5.</strong> The panel will have access to all prior correspondence relating to the complaint, and the results of any informal action or mediation.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0', paddingLeft: '25px' }}>
                    <strong>3.2.6.</strong> Notes of the hearing will be taken and made available to the complainant if requested. Verbatim minutes will not be recorded.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 3.3 Formal Stage II - Complaints against members of DTK */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h4 style={{ color: '#0369a1', fontSize: '1.6rem', fontWeight: '700', marginBottom: '20px' }}>
                    3.3. Formal (Stage II): Complaints against members of DTK
                  </h4>
                  
                  <div style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9' }}>
                    <p style={{ marginBottom: '15px', paddingLeft: '25px' }}>
                      <strong>3.3.1.</strong> The Complainant should write to the Director of Studies, outlining the reasons for the complaint progressing to the next stage. This should normally be done within 14 days of receipt of the response from stage I.
                    </p>

                    <p style={{ marginBottom: '15px', paddingLeft: '25px' }}>
                      <strong>3.3.2.</strong> Where an individual raises a complaint about another member/s of the organisation (student or staff member), an independent investigation will be initiated to consider the facts of the case. The complainant must supply full evidence and documentation to substantiate their allegations along with a summary of their complaint and details of any witnesses at this time.
                    </p>

                    <p style={{ marginBottom: '15px', paddingLeft: '25px' }}>
                      <strong>3.3.3.</strong> An Investigating Officer will be appointed, or a HR Officer (in the case of complaints against staff) or Student Services Team Member (in the case of complaints against students).
                    </p>

                    <p style={{ marginBottom: '15px', paddingLeft: '25px' }}>
                      <strong>3.3.4.</strong> The Investigating Officer (and advisers) will interview all relevant parties to the complaint. All individuals who are interviewed are entitled to be accompanied by a friend or representative of their choice at all stages of the process.
                    </p>

                    <p style={{ marginBottom: '15px', paddingLeft: '25px' }}>
                      <strong>3.3.5.</strong> When all evidence has been collected and the facts of the case have been identified, the Investigating Officer will act as the final arbiter in the complaint (i.e. if it has been upheld or not). The complainant will be notified of the decision and the basis for that decision.
                    </p>

                    <p style={{ marginBottom: '15px', paddingLeft: '25px' }}>
                      <strong>3.3.6.</strong> If the complaint is upheld the case will be referred to the DTK Director of Studies for possible action under the respective disciplinary procedures. The Investigating Officer will determine if there is a prima facia case against the student/staff member and where appropriate recommend that the case proceed to a disciplinary hearing. The Investigating Officer will present the case at any subsequent hearing. The Complaints Procedure does not form any part of the Disciplinary process. If the complaint is upheld, it is the decision of the Director to determine appropriate action.
                    </p>

                    <p style={{ marginBottom: '15px', paddingLeft: '25px' }}>
                      <strong>3.3.7.</strong> The Complainant should note that the decision whether to initiate disciplinary action against any member of DTK is a management decision and does not impact upon the outcome of the complaint. The outcome of any disciplinary action will remain confidential and is a management decision.
                    </p>

                    <p style={{ marginBottom: '15px', paddingLeft: '25px' }}>
                      <strong>3.3.8.</strong> If disciplinary action is taken, the complainant may be required to attend a formal disciplinary hearing in the capacity of witness to substantiate allegations.
                    </p>

                    <p style={{ marginBottom: '0', paddingLeft: '25px' }}>
                      <strong>3.3.9.</strong> If the member of DTK is disciplined and they wish to challenge this decision, they may do so under the appeals stage of their respective procedure (Staff Disciplinary Procedure). The complainant is a witness to the case and as such has no right of appeal over any sanction imposed at this stage under these procedures.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 3.4 Appeal */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h4 style={{ color: '#0369a1', fontSize: '1.6rem', fontWeight: '700', marginBottom: '20px' }}>
                    3.4 Appeal
                  </h4>
                  
                  <div style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9' }}>
                    <p style={{ marginBottom: '15px', paddingLeft: '25px' }}>
                      <strong>3.4.1.</strong> If the complainant feels that the procedures have not been followed or the decision is unreasonable, they have the right to appeal to the Director of Services within twenty-one (21) days of the announcement of the decision.
                    </p>

                    <p style={{ marginBottom: '15px', paddingLeft: '25px' }}>
                      <strong>3.4.2.</strong> The grounds for the appeal should be clearly stated and evidenced in writing and sent, in the first instance, to the Director of Services. Supporting papers should be included with the submission at this stage.
                    </p>

                    <p style={{ marginBottom: '15px', paddingLeft: '25px' }}>
                      <strong>3.4.3.</strong> The appeal will not consider new evidence, including witnesses, at this stage. If new evidence, including witnesses, has come to light which was not available for the individual at the first hearing, then the first hearing/investigation will be reconvened for the original Chair/Investigating Officer to consider the implications and effects of the new evidence.
                    </p>

                    <p style={{ marginBottom: '15px', paddingLeft: '25px' }}>
                      <strong>3.4.4.</strong> The papers will be forwarded to the or nominee who will decide if the appeal can be considered on the paper evidence submitted or a hearing is required.
                    </p>

                    <p style={{ marginBottom: '15px', paddingLeft: '25px' }}>
                      <strong>3.4.5.</strong> If deemed appropriate by the nominee, an appeal hearing may be convened with the nominee in the Chair. The Director of Services will act as adviser. The complainant and appropriate respondent will be required to attend any hearing convened under this appeal stage.
                    </p>

                    <p style={{ marginBottom: '15px', paddingLeft: '25px' }}>
                      <strong>3.4.6.</strong> Where an appeal hearing is deemed appropriate, it should normally be held within twenty-one (21) days of the request being made. Notes, not verbatim minutes, of the hearing will be taken and made available to the complainant.
                    </p>

                    <p style={{ marginBottom: '0', paddingLeft: '25px' }}>
                      <strong>3.4.7.</strong> The Nominee of any appeal will act as the arbiter in the matter and their decision will be final.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Note Box */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-4" style={{
                  backgroundColor: '#fef3c7',
                  borderRadius: '12px',
                  border: '2px solid #f59e0b'
                }}>
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '0', fontWeight: '500' }}>
                    <strong>NOTE:</strong> This Complaints Procedure shall from time to time be subject to review in the light of operating experience and/or changing circumstances.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Appendix I - Hearing Protocol */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <div className="text-center mb-4">
                    <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '10px' }}>
                      COMPLAINTS PROCEDURE: APPENDICES
                    </h3>
                    <h4 style={{ color: '#7B3F9E', fontSize: '1.5rem', fontWeight: '600' }}>
                      APPENDIX I HEARING PROTOCOL
                    </h4>
                  </div>

                  <ol style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', paddingLeft: '20px' }}>
                    <li style={{ marginBottom: '15px' }}>The Chair will open the hearing and outline the roles of all parties present.</li>
                    <li style={{ marginBottom: '15px' }}>The Chair shall confirm to the parties the nature of the complaint.</li>
                    <li style={{ marginBottom: '15px' }}>The Chair will inform the complainant of the right to be represented at the hearing should they arrive unaccompanied.</li>
                    <li style={{ marginBottom: '15px' }}>The Chair will ask the complainant (or representative) to present his/her case in support of their complaint. The complainant will be asked to introduce any witness(es) in support of the complaint.</li>
                    <li style={{ marginBottom: '15px' }}>The Complainant's representative may question the complainant and/or representative and/or any witness(es).</li>
                    <li style={{ marginBottom: '15px' }}>The Panel may ask questions of the complainant and/or representative and/or any witness(es) at any time.</li>
                    <li style={{ marginBottom: '15px' }}>The Chair will ask the Complainant's representative to reply to the complaint, and to introduce any witness(es) in support of the response.</li>
                    <li style={{ marginBottom: '15px' }}>The complainant (and/or representative) may question the Complainant's representative and/or any witness(es) called by the complainant in support of their response.</li>
                    <li style={{ marginBottom: '15px' }}>The Panel may ask questions of the Complainant's representative and any witness(es) at any time.</li>
                    <li style={{ marginBottom: '15px' }}>The Chair will ask the complainant (or representative) who is bringing the complaint to summarise their case.</li>
                    <li style={{ marginBottom: '15px' }}>The Chair will ask the Complainant's representative to summarise their case.</li>
                    <li style={{ marginBottom: '15px' }}>The Chair will then adjourn the hearing to consider the evidence that the Panel have heard. They may at this stage choose to seek additional evidence or information from other parties. Should this be the case, all parties will be informed as to the nature of the enquiry. The Relations Officer (or nominee) will advise the Panel.</li>
                    <li style={{ marginBottom: '15px' }}>Panel members will advise the Chair of their opinion of the case. Following this discussion, the Chair will act as final arbitrator in the matter.</li>
                    <li style={{ marginBottom: '0' }}>The Chair will announce their decision, either by calling the parties together or in writing. The outcome of the hearing will be confirmed in writing within five (5) working days of the decision.</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Appendix II - Flowchart */}
        <section style={{ padding: '0 0 80px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <div className="text-center mb-4">
                    <h4 style={{ color: '#7B3F9E', fontSize: '1.5rem', fontWeight: '600', marginBottom: '30px' }}>
                      APPENDIX II: FLOWCHART
                    </h4>
                  </div>

                  <div className="mb-4 p-4" style={{
                    backgroundColor: '#F5EBFA',
                    borderRadius: '12px',
                    border: '1px solid #7B3F9E'
                  }}>
                    <p style={{ color: '#334155', fontSize: '1rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      Prior to entering the Complaints Procedure, each complainant should normally have raised the issue with the person concerned. The formal complaints procedure should be a last resort in the search for a solution.
                    </p>
                    <p style={{ color: '#334155', fontSize: '1rem', lineHeight: '1.8', marginBottom: '0' }}>
                      Complainants who wish to raise a formal complaint should either complete a complaint form or write to the Director of Services
                    </p>
                  </div>

                  {/* Flowchart Visual - Matching PDF Layout */}
                  <div style={{ padding: '20px 0' }}>
                    {/* Initial Arrow Down */}
                    <div className="text-center mb-3">
                      <div style={{ 
                        width: '2px', 
                        height: '40px', 
                        backgroundColor: '#334155', 
                        margin: '0 auto',
                        position: 'relative'
                      }}>
                        <div style={{
                          position: 'absolute',
                          bottom: '-5px',
                          left: '50%',
                          transform: 'translateX(-50%)',
                          width: '0',
                          height: '0',
                          borderLeft: '6px solid transparent',
                          borderRight: '6px solid transparent',
                          borderTop: '8px solid #334155'
                        }}></div>
                      </div>
                    </div>

                    {/* Stage I - Informal & Mediation */}
                    <div className="mb-4 position-relative">
                      {/* Stage Label */}
                      <div style={{ position: 'absolute', left: '0', top: '50%', transform: 'translateY(-50%)' }}>
                        <div style={{
                          padding: '10px 15px',
                          backgroundColor: '#FAF8FC',
                          borderRadius: '8px',
                          fontWeight: '600',
                          color: '#0369a1',
                          fontStyle: 'italic',
                          fontSize: '0.9rem',
                          whiteSpace: 'nowrap'
                        }}>
                          INFORMAL &<br/>MEDIATION<br/>Stage I
                        </div>
                      </div>

                      <div style={{ marginLeft: '150px' }}>
                        <div className="row g-3">
                          <div className="col-6">
                            <div className="text-center p-3" style={{
                              backgroundColor: '#fff',
                              borderRadius: '8px',
                              border: '2px solid #334155'
                            }}>
                              <div style={{ fontSize: '0.95rem', color: '#334155' }}>Complaint resolved</div>
                              <div className="my-2">
                                <div style={{ 
                                  width: '2px', 
                                  height: '20px', 
                                  backgroundColor: '#334155', 
                                  margin: '0 auto',
                                  position: 'relative'
                                }}>
                                  <div style={{
                                    position: 'absolute',
                                    bottom: '-5px',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    width: '0',
                                    height: '0',
                                    borderLeft: '5px solid transparent',
                                    borderRight: '5px solid transparent',
                                    borderTop: '6px solid #334155'
                                  }}></div>
                                </div>
                              </div>
                              <div style={{ fontWeight: '700', fontSize: '1.1rem', color: '#334155' }}>END</div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="text-center p-3" style={{
                              backgroundColor: '#fff',
                              borderRadius: '8px',
                              border: '2px solid #334155'
                            }}>
                              <div style={{ fontSize: '0.95rem', color: '#334155', marginBottom: '5px' }}>Complaint unresolved</div>
                              <div className="my-2">
                                <div style={{ 
                                  width: '2px', 
                                  height: '20px', 
                                  backgroundColor: '#334155', 
                                  margin: '0 auto',
                                  position: 'relative'
                                }}>
                                  <div style={{
                                    position: 'absolute',
                                    bottom: '-5px',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    width: '0',
                                    height: '0',
                                    borderLeft: '5px solid transparent',
                                    borderRight: '5px solid transparent',
                                    borderTop: '6px solid #334155'
                                  }}></div>
                                </div>
                              </div>
                              <div style={{ fontSize: '0.9rem', color: '#334155' }}>Meeting requested with Director of Services if appropriate</div>
                            </div>
                          </div>
                        </div>

                        <div className="row g-3 mt-2">
                          <div className="col-6">
                            <div className="text-center p-3" style={{
                              backgroundColor: '#fff',
                              borderRadius: '8px',
                              border: '2px solid #334155'
                            }}>
                              <div style={{ fontSize: '0.95rem', color: '#334155' }}>Complaint resolved</div>
                              <div className="my-2">
                                <div style={{ 
                                  width: '2px', 
                                  height: '20px', 
                                  backgroundColor: '#334155', 
                                  margin: '0 auto',
                                  position: 'relative'
                                }}>
                                  <div style={{
                                    position: 'absolute',
                                    bottom: '-5px',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    width: '0',
                                    height: '0',
                                    borderLeft: '5px solid transparent',
                                    borderRight: '5px solid transparent',
                                    borderTop: '6px solid #334155'
                                  }}></div>
                                </div>
                              </div>
                              <div style={{ fontWeight: '700', fontSize: '1.1rem', color: '#334155' }}>END</div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="text-center p-3" style={{
                              backgroundColor: '#fff',
                              borderRadius: '8px',
                              border: '2px solid #334155'
                            }}>
                              <div style={{ fontSize: '0.95rem', color: '#334155' }}>Complaint unresolved</div>
                              <div className="my-2">
                                <div style={{ 
                                  width: '2px', 
                                  height: '20px', 
                                  backgroundColor: '#334155', 
                                  margin: '0 auto',
                                  position: 'relative'
                                }}>
                                  <div style={{
                                    position: 'absolute',
                                    bottom: '-5px',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    width: '0',
                                    height: '0',
                                    borderLeft: '5px solid transparent',
                                    borderRight: '5px solid transparent',
                                    borderTop: '6px solid #334155'
                                  }}></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Horizontal Separator */}
                    <div className="my-4" style={{ borderTop: '2px solid #334155' }}></div>

                    {/* Stage II - Formal */}
                    <div className="mb-4 position-relative">
                      {/* Stage Label */}
                      <div style={{ position: 'absolute', left: '0', top: '50%', transform: 'translateY(-50%)' }}>
                        <div style={{
                          padding: '10px 15px',
                          backgroundColor: '#FAF8FC',
                          borderRadius: '8px',
                          fontWeight: '600',
                          color: '#0369a1',
                          fontStyle: 'italic',
                          fontSize: '0.9rem',
                          whiteSpace: 'nowrap'
                        }}>
                          FORMAL<br/>Stage II
                        </div>
                      </div>

                      <div style={{ marginLeft: '150px' }}>
                        <div className="row g-3">
                          <div className="col-6">
                            <div className="text-center p-3" style={{
                              backgroundColor: '#fff',
                              borderRadius: '8px',
                              border: '2px solid #334155'
                            }}>
                              <div style={{ fontSize: '0.95rem', color: '#334155', marginBottom: '5px' }}>General complaint</div>
                              <div className="my-2">
                                <div style={{ 
                                  width: '2px', 
                                  height: '20px', 
                                  backgroundColor: '#334155', 
                                  margin: '0 auto',
                                  position: 'relative'
                                }}>
                                  <div style={{
                                    position: 'absolute',
                                    bottom: '-5px',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    width: '0',
                                    height: '0',
                                    borderLeft: '5px solid transparent',
                                    borderRight: '5px solid transparent',
                                    borderTop: '6px solid #334155'
                                  }}></div>
                                </div>
                              </div>
                              <div style={{ fontSize: '0.9rem', color: '#334155' }}>Oral hearing</div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="text-center p-3" style={{
                              backgroundColor: '#fff',
                              borderRadius: '8px',
                              border: '2px solid #334155'
                            }}>
                              <div style={{ fontSize: '0.95rem', color: '#334155', marginBottom: '5px' }}>Student complaint</div>
                              <div className="my-2">
                                <div style={{ 
                                  width: '2px', 
                                  height: '20px', 
                                  backgroundColor: '#334155', 
                                  margin: '0 auto',
                                  position: 'relative'
                                }}>
                                  <div style={{
                                    position: 'absolute',
                                    bottom: '-5px',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    width: '0',
                                    height: '0',
                                    borderLeft: '5px solid transparent',
                                    borderRight: '5px solid transparent',
                                    borderTop: '6px solid #334155'
                                  }}></div>
                                </div>
                              </div>
                              <div style={{ fontSize: '0.9rem', color: '#334155' }}>Independent investigation Complainant advised of decision</div>
                            </div>
                          </div>
                        </div>

                        <div className="row g-3 mt-2">
                          <div className="col-3">
                            <div className="text-center p-2" style={{
                              backgroundColor: '#fff',
                              borderRadius: '8px',
                              border: '2px solid #334155'
                            }}>
                              <div style={{ fontSize: '0.85rem', color: '#334155' }}>Complaint resolved</div>
                              <div className="my-2">
                                <div style={{ 
                                  width: '2px', 
                                  height: '15px', 
                                  backgroundColor: '#334155', 
                                  margin: '0 auto',
                                  position: 'relative'
                                }}>
                                  <div style={{
                                    position: 'absolute',
                                    bottom: '-4px',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    width: '0',
                                    height: '0',
                                    borderLeft: '4px solid transparent',
                                    borderRight: '4px solid transparent',
                                    borderTop: '5px solid #334155'
                                  }}></div>
                                </div>
                              </div>
                              <div style={{ fontWeight: '700', fontSize: '1rem', color: '#334155' }}>END</div>
                            </div>
                          </div>
                          <div className="col-3">
                            <div className="text-center p-2" style={{
                              backgroundColor: '#fff',
                              borderRadius: '8px',
                              border: '2px solid #334155'
                            }}>
                              <div style={{ fontSize: '0.85rem', color: '#334155' }}>Complaint unresolved</div>
                              <div className="my-2">
                                <div style={{ 
                                  width: '2px', 
                                  height: '15px', 
                                  backgroundColor: '#334155', 
                                  margin: '0 auto',
                                  position: 'relative'
                                }}>
                                  <div style={{
                                    position: 'absolute',
                                    bottom: '-4px',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    width: '0',
                                    height: '0',
                                    borderLeft: '4px solid transparent',
                                    borderRight: '4px solid transparent',
                                    borderTop: '5px solid #334155'
                                  }}></div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-3">
                            <div className="text-center p-2" style={{
                              backgroundColor: '#fff',
                              borderRadius: '8px',
                              border: '2px solid #334155'
                            }}>
                              <div style={{ fontSize: '0.85rem', color: '#334155' }}>Complaint resolved</div>
                              <div className="my-2">
                                <div style={{ 
                                  width: '2px', 
                                  height: '15px', 
                                  backgroundColor: '#334155', 
                                  margin: '0 auto',
                                  position: 'relative'
                                }}>
                                  <div style={{
                                    position: 'absolute',
                                    bottom: '-4px',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    width: '0',
                                    height: '0',
                                    borderLeft: '4px solid transparent',
                                    borderRight: '4px solid transparent',
                                    borderTop: '5px solid #334155'
                                  }}></div>
                                </div>
                              </div>
                              <div style={{ fontWeight: '700', fontSize: '1rem', color: '#334155' }}>END</div>
                            </div>
                          </div>
                          <div className="col-3">
                            <div className="text-center p-2" style={{
                              backgroundColor: '#fff',
                              borderRadius: '8px',
                              border: '2px solid #334155'
                            }}>
                              <div style={{ fontSize: '0.85rem', color: '#334155' }}>Complaint unresolved</div>
                              <div className="my-2">
                                <div style={{ 
                                  width: '2px', 
                                  height: '15px', 
                                  backgroundColor: '#334155', 
                                  margin: '0 auto',
                                  position: 'relative'
                                }}>
                                  <div style={{
                                    position: 'absolute',
                                    bottom: '-4px',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    width: '0',
                                    height: '0',
                                    borderLeft: '4px solid transparent',
                                    borderRight: '4px solid transparent',
                                    borderTop: '5px solid #334155'
                                  }}></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Horizontal Separator */}
                    <div className="my-4" style={{ borderTop: '2px solid #334155' }}></div>

                    {/* Stage III - Appeal */}
                    <div className="position-relative">
                      {/* Stage Label */}
                      <div style={{ position: 'absolute', left: '0', top: '50%', transform: 'translateY(-50%)' }}>
                        <div style={{
                          padding: '10px 15px',
                          backgroundColor: '#FAF8FC',
                          borderRadius: '8px',
                          fontWeight: '600',
                          color: '#0369a1',
                          fontStyle: 'italic',
                          fontSize: '0.9rem',
                          whiteSpace: 'nowrap'
                        }}>
                          APPEAL<br/>Stage III
                        </div>
                      </div>

                      <div style={{ marginLeft: '150px' }}>
                        <div className="row g-3">
                          <div className="col-6">
                            <div className="text-center p-3" style={{
                              backgroundColor: '#fff',
                              borderRadius: '8px',
                              border: '2px solid #334155'
                            }}>
                              <div style={{ fontSize: '0.9rem', color: '#334155', marginBottom: '5px' }}>Appeal to<br/>Director of<br/>Services<br/>(or nominee)</div>
                              <div className="my-2">
                                <div style={{ 
                                  width: '2px', 
                                  height: '20px', 
                                  backgroundColor: '#334155', 
                                  margin: '0 auto',
                                  position: 'relative'
                                }}>
                                  <div style={{
                                    position: 'absolute',
                                    bottom: '-5px',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    width: '0',
                                    height: '0',
                                    borderLeft: '5px solid transparent',
                                    borderRight: '5px solid transparent',
                                    borderTop: '6px solid #334155'
                                  }}></div>
                                </div>
                              </div>
                              <div style={{ fontWeight: '700', fontSize: '1.1rem', color: '#334155' }}>END</div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="text-center p-3" style={{
                              backgroundColor: '#fff',
                              borderRadius: '8px',
                              border: '2px solid #334155'
                            }}>
                              <div style={{ fontSize: '0.9rem', color: '#334155', marginBottom: '5px' }}>Appeal to<br/>Director of<br/>Services<br/>(or nominee)</div>
                              <div className="my-2">
                                <div style={{ 
                                  width: '2px', 
                                  height: '20px', 
                                  backgroundColor: '#334155', 
                                  margin: '0 auto',
                                  position: 'relative'
                                }}>
                                  <div style={{
                                    position: 'absolute',
                                    bottom: '-5px',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    width: '0',
                                    height: '0',
                                    borderLeft: '5px solid transparent',
                                    borderRight: '5px solid transparent',
                                    borderTop: '6px solid #334155'
                                  }}></div>
                                </div>
                              </div>
                              <div style={{ fontWeight: '700', fontSize: '1.1rem', color: '#334155' }}>END</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default ComplaintPolicy;